<template>
  <v-container class="mt-2 pr-2">
    <v-row>
      <v-col cols="12">
        <!-- Buscador -->
        <v-card-title primary-title>
          <v-text-field
            dense
            filled
            single-line
            hide-details
            label="Búscar"
            v-model="search"
            append-icon="mdi-magnify"
          ></v-text-field>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          
          <v-btn  class="orange" small tile dark @click="initialize" ><v-icon>mdi-refresh</v-icon> </v-btn>

        </v-card-title>
      </v-col>

      <!-- Catalago en forma de carts -->
      <v-col cols="12" xl="4" lg="4" md="6"  v-for="(a, i) in filterUsuarios" :key="i">
        <!-- usuarios -->
        <v-card class="shadowCard mb-4">
          <v-row>
            <v-col cols="12" >
              <v-card-text align="center" class="mb-0 pb-0 text-h5">
                <b>{{a.nomuser}}</b><br/>
              </v-card-text>
              <v-card-title primary-title class="mt-0 pt-0">
                Accesos 
                <v-btn color="blue" icon tile small dark class="ml-2" @click="dialogAddAcceso = true, idselectUser = a.id, getRuta()"><v-icon>mdi-plus-circle</v-icon></v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-data-table
                :loading="loading"
                :headers="headersAccesos"
                :items="a.accesos"
                fixed-header
                :height="200"
                hide-default-footer
                loading-text="Cargando..."
                dense
                :items-per-page="100"
                :mobile-breakpoint="250"
              >
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="red"
                    small
                    @click="dialogDeleteAcceso = true, idaccesos = item.idaccesos"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                </v-card-title>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    

    <!-- Eliminar la acceso de un articulo -->
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteAcceso" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Eliminar Acceso</v-card-title>
          <v-card-text>¿Deseas eliminar permanentemente el acceso?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialogDeleteAcceso = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="deleteAcceso">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Agregar rutas al artículo -->
    <v-row justify="center">
      <v-dialog v-model="dialogAddAcceso" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Agregar acceso</v-card-title>
          <v-card-text>
            <v-select 
              dense
              filled
              :items="rutas"
              v-model="ruta"
              item-text="nomruta"
              item-value="idruta" 
              label="Proyecto"
              persistent-hint
              single-line
              hide-details
              return-object
            ></v-select>
            {{mensaje}}
          </v-card-text>

          <v-card-actions>
	          <v-btn
	            color="black"
	            dark
	            small
	            @click="dialogAddAcceso = false"
	            tile
	            dense
	          >
	          	<v-icon left small>mdi-close</v-icon>
	            Cancelar
	          </v-btn>
	          <v-spacer></v-spacer>
	          <v-btn
	            color="primary"
	            small
	            dark
	            @click="save"
	            tile
	          >
	          	<v-icon left small>mdi-content-save</v-icon>
	            Guardar
	          </v-btn>
	        </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      // Alerta
      snackbar:false,
      color:'',
      mensaje:'',
      // modo
      modo: 1, // 1 nuevo, 2 editar,

      // nuevo articulo
      dialog: false,

      idruta:0,
      mensaje:'',
      dialogAddAcceso: false,
      dialogDeleteAcceso:false,
      loading:true,
      idselectUser:0,
      dialogDeleteArt: false,
      
      rutas:[],
      ruta:{idruta:'', nomruta:'', ruta:''},
      headersAccesos: [
        { text: 'Proyecto', align: 'start', value: 'nomruta'},
        { text: 'id', align: 'start', value: 'idaccesoss'},
        { text: 'Acciones', align: 'end', value: 'actions'},
      ],

      usuarios: [],
      search:'',
      longitud:100,
    }),


    watch: {
      dialog (val) {
        val || this.close()
      },

      categoria(){
        this.mensaje = ''
        console.log(this.categoria)
      }
    },

    created () {
      this.initialize()
      this.url = this.$http.options.root + 'fotos/'
    },

    methods: {
      initialize () {
        this.usuarios = []
        this.cargar = true
        this.$http.get('accesos.all').then(response=>{
          console.log(response.body)
          this.usuarios = response.body
          this.longitud = this.usuarios.length
          this.loading = false
          this.cargar  = false
        }).catch(error=>{this.cargar = false})
      },


      getRuta(){
        this.cargar = true
        this.$http.get('rutas.all').then(response=>{
          this.rutas  = response.body
          this.cargar = false
        }).catch(error=>{this.cargar = false})
      },

      save(){
        this.cargar = true
        var payload ={
          idusuario: this.idselectUser,
          idruta: this.ruta.idruta
        }
        this.$http.post('accesos.add',payload).then(response=>{
          this.mensaje = 'Acceso agregado'
          this.cargar  = false
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      deleteAcceso(){
        this.cargar = true
        this.$http.delete('accesos.delete/' + this.idaccesos).then(response=>{
          this.validarSuccess('Acceso eliminado correctamente')
          this.initialize()
          this.dialogDeleteAcceso = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },


    },

    computed:{

      filterUsuarios: function(){
        var me = this
        if(this.usuarios){
          return this.usuarios.filter((art)=>{
            var nom = art.nomuser.toLowerCase();
            return nom.match(this.search.toLowerCase());
          })
        }
      },
    }
  }
</script>
<style scoped>

.v-data-table__wrapper{

}

.v-data-table__wrapper::-webkit-scrollbar {
    -webkit-appearance: none !important;
}

.v-data-table--fixed-header > .v-data-table__wrapper::-webkit-scrollbar:vertical {
  width:10px !important;
}

.v-data-table__wrapper::-webkit-scrollbar:vertical {
  width:10px !important;
}

.v-data-table__wrapper::-webkit-scrollbar:vertical {
    width:10px !important;
}

.v-data-table__wrapper::-webkit-scrollbar-button:increment,.v-data-table__wrapper::-webkit-scrollbar-button {
    display: none;
} 

.v-data-table__wrapper::-webkit-scrollbar:horizontal {
    height: 10px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb {
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ffffff;
}

</style>
